import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { Country } from '@shared/models';
import { MiscService } from '@shared/services';
import { FetchCountries } from '@shared/store/shared.actions';

export interface SharedStateModel {
  countries?: Country[];
}

@State<SharedStateModel>({
  name: 'shared',
  defaults: {},
})
@Injectable()
export class SharedState {
  constructor(private miscService: MiscService) {}

  @Selector()
  static getCountries(state: SharedStateModel): Country[] | undefined {
    return state.countries;
  }

  @Action(FetchCountries)
  fetchCountries(
    ctx: StateContext<SharedStateModel>
  ): Observable<Country[] | undefined> | undefined {
    const { countries } = ctx.getState();

    if (countries) {
      return;
    }

    return this.miscService.getCountries().pipe(
      tap(data => {
        ctx.patchState({ countries: data });
      })
    );
  }
}
